import comp from "./VoiceRecorderV2";
export default comp;
